import { useIsFeatureRolloutEnabled } from '@ms/yammer-hooks/dist/featureRollouts';

import { UseUIFeatureCheck } from '../types';

export const useIsChatEnabled: UseUIFeatureCheck = () => useIsFeatureRolloutEnabled('TeamsChatButton');
